import { ManagerStoreActionsClass } from './ManagerStoreActionsClass';

const ManagerStore: ManagerStoreActionsClass = new ManagerStoreActionsClass();

export { ManagerStore };
